import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import eventsEN from '../events/events_EN.json';
import eventsRU from '../events/events_RU.json';

export default function EventDetails() {
  const { strings, lang_code } = useLanguage();
  const [event, setEvent] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {

    const langSuffix = strings.lang_code.toLowerCase();
    const eventId = searchParams.get('eventid');
    const loadEventsWithSnippets = async (eventId) => { 
            try {
              const snippetModule = await import(`../events/${eventId}_${langSuffix.toUpperCase()}.js`);
              console.log(`Loaded snippet module for event ${event.id}:`, snippetModule);
              setEvent(snippetModule.default)
              console.log(`Loaded snippet for event ${eventId}:`, event);
            } catch (error) {
              console.log(`Error loading snippet for event ${eventId}:`, error);
              setEvent("No content found");
  
            }
          }
  loadEventsWithSnippets(eventId);  
  }, [strings.lang_code]);



  return (
  <div className="content-wrapper">
  {event}
  </div>
  );
}

